import type { SnsTopicKey } from './topics';
import type { EntityCrudEventPayload, SqsEventPayloads, SqsEventType } from './types';

export type SqsEventRoute<TPayload> = {
  topicKey: SnsTopicKey;
  messageGroupId?: (payload: TPayload) => string;
  messageDeduplicationId?: (payload: TPayload) => string;
};

/**
 * CRUD routes deliberately do not derive a deduplication id from the payload.
 *
 * The obvious key - `entityId:operation:changedAt` - is unsafe: `changedAt` comes from
 * `lastChangedDateTime`, which PostgresModule formats to whole seconds, so two genuine
 * updates to one row inside the same second would collide and SNS would silently drop
 * the second for five minutes. Falling back to the envelope's per-message id (see
 * EventBusService) keeps a retried publish idempotent without ever merging two distinct
 * changes.
 */
function entityCrudRoute(topicKey: SnsTopicKey): SqsEventRoute<EntityCrudEventPayload> {
  return {
    topicKey,
    messageGroupId: payload => payload.entityId
  };
}

export const SQS_EVENT_ROUTES = {
  'appointment.crud': entityCrudRoute('appointmentCrud'),
  'warehouse.crud': entityCrudRoute('warehouseCrud'),
  'asset-visit.crud': entityCrudRoute('assetVisitCrud'),
  'bol.crud': entityCrudRoute('bolCrud'),
  'asset-visit-event.crud': entityCrudRoute('assetVisitEventCrud')
} satisfies {
  [TEventType in SqsEventType]: SqsEventRoute<SqsEventPayloads[TEventType]>;
};
